// Rejected goods step 3a (2026-10-25, mockup "Payments & ADIB"): after saving a direct purchase or a receipt the ERP asks
// "Record the payment now?". One helper for the PO page and Expected deliveries: ask(poId, then) shows the question (only to people
// who may record payments) and the Record payment window; `then` runs afterwards either way (e.g. go to the receipt).
import React, { useRef, useState } from 'react';
import { Modal } from 'antd';
import { useAuth } from '../../context/AuthContext';
import RecordPaymentWindow from './RecordPaymentWindow';

export function useRecordPaymentPrompt(onRecorded?: () => void) {
  const { canAccess } = useAuth();
  const [poId, setPoId] = useState<string | null>(null);
  const after = useRef<(() => void) | null>(null);
  const done = () => { const f = after.current; after.current = null; f?.(); };
  const ask = (po: string, then?: () => void) => {
    if (!canAccess('purchasing.account', 'create')) { then?.(); return; }
    after.current = then || null;
    Modal.confirm({
      title: 'Record the payment now?',
      content: 'How it was paid, the amount and the proof. You can also do it later from the PO page.',
      okText: 'Record payment', cancelText: 'Later',
      onOk: () => setPoId(po),
      onCancel: done,
    });
  };
  const element = (
    <RecordPaymentWindow
      poId={poId}
      onClose={() => { setPoId(null); done(); }}
      onSaved={() => { setPoId(null); onRecorded?.(); done(); }}
    />
  );
  return { ask, element };
}
